import { showStateDevTools } from "@/config/environmentUtils";

import { StateDevTools } from "./state-dev-tools.component";

export const StateDevToolsWrapper = () => {
  if (!showStateDevTools()) return null;

  return <StateDevTools />;
};
